import {PRIVACY_POLICY_URL, HELP_EMAIL} from "constants.js";

export default {
    translation: {
        "common": {
            "step": "Step",
            "price-yearly": "[price] anno",
            "select": "Scegli...",
            "gender": {
                "male": "Maschio",
                "female": "Femmina",
                "non-binary": "Non binario",
                "other": "Altro",
                "no-response": "Preferisco non rispondere"
            },
            "loading": "Sto caricando...",
            "associated-companies-single": "azienda associata",
            "associated-companies-plural": "aziende associate",
            "role-of": "Ruolo di",
            "optional": "opzionale",
            "home-breadcrumb": "Portale",
            "new": "Nuovo!",
            "directory": {
                "data": "[count] Video | [duration] Minuti"
            },
            "all": {
                "female": "Tutte",
                "male": "Tutti"
            },
            "order-by": {
                "placeholder": "Ordina per"
            },
            "material": "Materiale e link",
            "upsell": {
                "upgrade": "Accesso riservato ad un altro piano",
                "pay-video": "Sblocca il contenuto di questa lezione per €[price]",
                "pay-directory": "Sblocca il contenuto di questa rubrica per €[price]"
            },
            "like-to-users": "Piace a **[count]** imprenditori",
            "first-to-like": "Lascia like\nper primo!",
            "like-to-you-and-users": "Piace a **te** ed altri **[count]** imprenditori",
            "like-only-you": "Piace solo a **te**",
            "comment": {
                "single": "Commento",
                "multiple": "Commenti",
                "no-comments": "Nessun commento"
            },
            "do-comment": "Commenta",
            "you": "Tu",
            "speaker": "Speaker",
            "card": "Carta",
            "new-card": "Nuova carta",
            "search": "Cerca...",
            "searching": "Sto ricercando...",
            "event-type": {
                "online": "Evento online",
                "live": "Evento live"
            },
            "token-expired": "La tua sessione è scaduta, effettua nuovamente il login.",
            "for": "per",
            "personal-area": "Area personale",
            "opened-at-by": "Aperto il [date] da",
            "response": {
                "single": "Risposta",
                "plural": "Risposte"
            },
            "last": "ultima",
            "you-voted": "Hai votato - ",
            "votes": {
                "single": "Voto",
                "plural": "Voti"
            },
            "thread": {
                "request": "Richiesta di aiuto",
                "best_answer": "Miglior risposta di"
            },
            "achievements": {
                "level": {
                    "pro": "PRO",
                    "active": "Active",
                    "expert": "Expert"
                }
            },
            "at": "di",
            "video-type": {
                "normal": "Video",
                "cta": "Call to action",
                "training": "Allenamento"
            },
            "audace": "Audace"
        },
        "menu": {
            "for-you": "Per te",
            "videos": "Tutti i video",
            "events": "Tutti gli eventi",
            "threads": "Richieste & Discussioni",
            "people": "Persone & Aziende"
        },
        "validator": {
            "invalid-email": "Inserisci una email con formato valido (email@email.it)",
            "invalid-password": "Inserisci una password di almeno 8 caratteri",
            "password-no-match": "Le password non coincidono",
            "required": "Il campo è obbligatorio",
            "phone-needs-prefix": "Il numero di telefono deve comprendere il prefisso ( +39 )",
            "wrong-card-number": "Numero non valido",
            "wrong-card-exp": "Scadenza non valida, deve essere MM/YY",
            "wrong-card-cvv": "CVV non valido"
        },
        "404": {
            "title":"Questa pagina non esiste",
            "text": "Il link è errato o scaduto.Clicca il tasto in basso per tornare alla home."
        },
        "buttons": {
            "show-attachment": "Vedi allegato",
            "publish": "Pubblica",
            "back-home": "Torna alla home",
            "need-help": "Bisogno di aiuto?",
            "forgot-password": "Ho dimenticato la password",
            "login": "Accedi",
            "send": "Invia",
            "forgot-email": "Ho dimenticato anche l'email",
            "ok-thanks": "Ok grazie",
            "ok-close": "Ok chiudi",
            "save-next": "Salva e continua",
            "cancel": "Annulla",
            "wannabe-knight": "Voglio diventare un cavaliere!",
            "next-step": "Prossimo step",
            "next": "Continua",
            "go-to-profile": "Vai al profilo",
            "upload": "Carica",
            "upload-image": "Carica immagine",
            "associate-company": "Associa azienda esistente",
            "new-company": "Inserisci nuova azienda",
            "do-associate-company":"Convalida dati e associa",
            "do-disassociate-company": "Sconnetti dall'azienda",
            "do-disassociate-user": "Sconnetti [name]",
            "go-back": "Torna indietro",
            "check-and-complete": "Controlla e completa dati",
            "edit": "Modifica",
            "edit-data": "Modifica dati",
            "save-data": "Salva dati",
            "add-company-address": "Aggiungi altra sede",
            "delete-company-address": "Elimina sede",
            "choose-doc": "Scegli documento",
            "company-add-product": "Aggiungi altro prodotto/servizio",
            "profile-complete": "Profilo completo",
            "copy-code": "Copia codice",
            "update-code": "Aggiorna codice",
            "do-logout": "Ok, esci dall'account",
            "tutorial": "Vedi tutorial",
            "load-more": "Carica altri...",
            "previous-item": "Precedente",
            "next-item": "Seguente",
            "show-directory": "Visualizza rubrica",
            "upsell": {
                "upgrade": "Contatta il supporto",
                "pay": "Vai al pagamento"
            },
            "delete": "Elimina",
            "show-filters": "Mostra filtri",
            "copy-link": "Copia link",
            "copy-qr": "Scarica QR Code",
            "change-password": "Cambia password",
            "confirm-new-password": "Conferma nuova password",
            "save-edited-data": "Salva modifiche ai dati",
            "add-card": "Aggiungi carta",
            "send-delete-request": "Invia richiesta cancellazione",
            "delete-all": "Elimina tutte",
            "contact-name": "Contatta [name]",
            "send-us-email": "Inviaci un email",
            "report-problem": "Segnala un problema",
            "close": "Chiudi",
            "new-thread": "Apri discussione",
            "archive": "Archivia",
            "delete-thread": "Elimina la discussione",
            "delete-thread-confirm": "Conferma elimina discussione",
            "you-confirmed": "Hai confermato",
            "confirm": "Conferma",
            "send-message-to": "Invia messaggio a [name]",
            "send-recommendation-to": "Invia raccomendazione a [name]"
        },
        "toasts": {
            "copied": "Copiato negli appunti",
            "downloaded": "Download file iniziato"
        },
        "modal": {
            "associate-company": {
                "title": "Associa azienda",
                "text": "Inserisci ragione sociale e il codice segreto che può avere solo l’amministratore dell’azienda.",
                "company": {
                    "placeholder": "Ragione sociale",
                    "hint": "Esempio: Azienda srl"
                },
                "secret": {
                    "placeholder": "Codice segreto",
                    "hint": "Da richiedere all'amministratore"
                },
                "role": {
                    "placeholder": "Ruolo in azienda"
                }
            },
            "disassociate-company": {
                "title": "Scollega da azienda",
                "text": "Confermando verrai dissociato dall’azienda selezionata."
            },
            "disassociate-user": {
                "title": "Vuoi sconnettere [name]?",
                "text": "Se confermi in collaboratore non sarà più associato all’azienda."
            },
            "onboarding-complete": {
                "title": "Profilo completo, siamo pronti per iniziare!",
                "text": "Il tuo profilo è completo e puoi iniziare la tua esperienza di crescita professionale.\nBuon business!"
            },
            "logout": {
                "title": "Esci dall'account",
                "text": "Al prossimo accesso ti verranno chieste le credenziali per accedere."
            },
            "edit-comment": {
                "title": "Modifica commento"
            },
            "attachment-comment": {
                "title": "Commenta e allega",
                "attachment": {
                    "title": "Il tuo allegato",
                    "button": "Scegli documento"
                }
            },
            "search": {
                "placeholder": "Cerca argomento, evento, speaker o parola chiave",
                "short-placeholder": "Cosa stai cercando?",
                "no-results": "Nessun risultato",
                "video": "Formazione",
                "directory": "Rubriche",
                "event": "Eventi",
                "threads": "Discussioni",
                "users": "Persone",
                "companies": "Aziende"
            },
            "delete-account": {
                "title": "Richiedi cancellazione account",
                "text": "Stai per inviare una richiesta al team di amministrazione affinché il tuo account venga eliminato. Verrai contattato per concordare le modalità di uscita dalla Cerchia degli Audaci.",
                "success": "Richiesta di cancellazione inviata correttamente, sarai ricontattato dal team di amministrazione."
            },
            "thread-archive": {
                "title": "Vuoi archiviare e bloccare le risposte?",
                "text": "Procedendo archivi la discussione bloccando la possibilità ad altri di inviare nuove risposte o di votare quelle presenti.\n\nManderemo un messaggio di ringraziamento a chi ha commentato con la migliore risposta che, se ha avuto più di 5 voti, riceverà un badge “top risposta” sulle categorie della discussione o richiesta. Procediamo?",
                "button": "Archivia e ringrazia tutti"
            },
            "send-message": {
                "title": "Scrivi un messaggio",
                "success": "Messaggio inviato correttamente",
                "placeholder": "Max 500 caratteri"
            },
            "send-recommendation": {
                "title": "Invia raccomandazione",
                "success": "Raccomendazione inviata correttamente",
                "placeholder": "Max 500 caratteri"
            }
        },
        "footer": {
            "vat": "P.IVA/C.F",
            "privacy": "Privacy Policy"
        },
        "text-fields": {
            "email": {
                "placeholder": "La tua email",
                "placeholder-short": "Email",
                "hint": "Email dell'account"
            },
            "password": {
                "placeholder": "Password",
                "hint": "Minimo 8 caratteri"
            },
            "old-password": {
                "placeholder": "Attuale Password",
                "hint": "Minimo 8 caratteri"
            },
            "confirm-password": {
                "placeholder": "Conferma password",
                "hint": "Minimo 8 caratteri"
            },
            "first-name": {
                "placeholder": "Nome"
            },
            "last-name": {
                "placeholder": "Cognome"
            },
            "phone": {
                "placeholder": "Numero di telefono"
            },
            "card-number": {
                "placeholder": "Numero carta"
            },
            "card-holder": {
                "placeholder": "Intestatario carta"
            },
            "card-exp": {
                "placeholder": "Scadenza",
                "hint": "Mese e anno"
            },
            "card-cvv": {
                "placeholder": "CVV",
                "hint": "3 cifre sul retro"
            },
            "invoice": {
                "name": {
                    "placeholder": "Ragione sociale"
                },
                "vat-cf": {
                    "placeholder": "P.IVA o Codice Fiscale"
                },
                "address": {
                    "placeholder": "Indirizzo e civico"
                },
                "city": {
                    "placeholder": "Città"
                },
                "zip": {
                    "placeholder": "Cap"
                },
                "province": {
                    "placeholder": "Provincia"
                },
                "ade_code": {
                    "placeholder": "Codice destinatario*"
                },
                "pec": {
                    "placeholder": "Indirizzo pec*"
                }
            },
            "terms" : {
                "label": `Acconsento al trattamento dei dati come espresso nell’[informativa sulla privacy](${PRIVACY_POLICY_URL})`
            },
            "gender": {
                "placeholder": "Genere"
            },
            "osa-office": {
                "placeholder": "Sede OSA"
            },
            "birth-date": {
                "placeholder": "Data di nascita"
            },
            "userbio": {
                "placeholder": "Raccontaci qualcosa di te"
            },
            "languages": {
                "placeholder": "Lingue parlate"
            },
            "linkedin": {
                "placeholder": "Profilo Linkedin personale (opzionale)"
            },
            "twitter": {
                "placeholder": "Account Twitter personale (opzionale)"
            },
            "website": {
                "placeholder": "Sito web personale (opzionale)"
            },
            "link-title": {
                "placeholder": "Titolo Link"
            },
            "link": {
                "placeholder": "Link"
            },
            "company-name": {
                "placeholder": "Ragione sociale azienda"
            },
            "company-name-short": {
                "placeholder": "Nome ridotto (opzionale)"
            },
            "role": {
                "placeholder": "Ruolo"
            },
            "vat": {
                "placeholder": "Partita IVA/Codice Fiscale"
            },
            "ade-code": {
                "placeholder": "Codice destinatario"
            },
            "creation-year": {
                "placeholder": "Anno di creazione"
            },
            "employees": {
                "placeholder": "Numero dipendenti"
            },
            "osa-center": {
                "placeholder": "Centro OSA"
            },
            "reference-sector": {
                "placeholder": "Settore di riferimento"
            },
            "company-address-type": {
                "placeholder": "Tipologia"
            },
            "full-address": {
                "placeholder": "Indirizzo completo"
            },
            "zip": {
                "placeholder": "Cap"
            },
            "province": {
                "placeholder": "Provincia"
            },
            "country": {
                "placeholder": "Nazione"
            },
            "company-phone": {
                "placeholder": "Numero telefono aziendale"
            },
            "company-email": {
                "placeholder": "Email aziendale"
            },
            "company-linkedin": {
                "placeholder": "Profilo Linkedin aziendale (opzionale)"
            },
            "company-twitter": {
                "placeholder": "Twitter aziendale (opzionale)"
            },
            "company-website": {
                "placeholder": "Sito web aziendale (opzionale)"
            },
            "company-description": {
                "placeholder": "Racconta cosa offre la tua azienda per promuoverti"
            },
            "company-video": {
                "placeholder": "Link ad un video di presentazione"
            },
            "product-description": {
                "placeholder": "Descrizione del prodotto/servizio"
            },
            "product-title": {
                "placeholder": "Titolo del prodotto/servizio"
            },
            "comment-video": {
                "placeholder": "Commenta il video"
            },
            "comment-event": {
                "placeholder": "Commenta l'evento"
            },
            "comment-thread": {
                "placeholder": "Commenta la discussione"
            },
            "thread-title": {
                "placeholder": "Titolo che tutti vedranno"
            },
            "osa-offices": {
                "placeholder": "Sedi OSA"
            },
            "roles": {
                "placeholder": "Ruoli"
            }
        },
        "forms": {
            "payment": {
                "title": "Dati pagamento",
                "text": "Utilizziamo un sistema di pagamento sicuro e garantito, tramite il servizio Stripe. Al rinnovo deciderai tu se continuare o meno."
            },
            "invoice": {
                "title": "Dati di fatturazione",
                "text": `Per maggiori informazioni sulla fattura elettronica [clicca qui](/help).`,
                "note": "\\* Codice destinatario o indirizzo pec (uno dei due) obbligatori."
            },
            "profile-edit": {
                "image-text":"Scegli una foto che ti rappresenta.",
                "image-pref": "La foto non è obbligatoria ma preferibile",
                "base-info": {
                    "title": "Informazioni di base"
                },
                "description": {
                    "title":"Descrizione e contatti personali"
                },
                "skills": {
                    "title": "Competenze e interessi personali",
                    "skill": {
                        "text": "Inserisci almeno 3 competenze professionali (fino a 10).\nSaranno visibili sul profilo da parte di chiunque lo vedrà.",
                        "placeholder": "Scrivi per creare e aggiungere una competenza (premi invio)"
                    },
                    "interest": {
                        "text": "Inserisci almeno 3 interessi personali (fino a 10).\nLi vedrai solo tu e ci serviranno per consigliarti contenuti perfetti per te.",
                        "placeholder": "Scrivi per cercare un interesse"
                    }
                },
                "other": {
                    "title": "Altri link e documenti extra",
                    "text": "Se vuoi puoi aggiungere altri link a siti web, documenti, video, curriculum o altro che ti rappresenta."
                }
            },
            "company-upsert": {
                "title-edit": "Sei amministratore di [companyName]",
                "title-new": "Compila i dati per inserire una nuova azienda",
                "general-data": "Informazioni generali",
                "company-address": "Indirizzo aziendale",
                "contacts": "Contatti aziendali",
                "description": "Descrizione e materiali (opzionali)",
                "products": "Prodotti o servizi (opzionali)",
                "upload-logo": "Carica il logo",
                "upload-doc": "Carica un documento PDF",
                "skills": {
                    "skill": {
                        "text": "Inserisci fino a 10 competenze aziendali.\nSaranno visibili sul profilo aziendale.",
                        "placeholder": "Scrivi per cercare una competenza"
                    }
                },
            }
        },
        "login": {
            "title": "Accedi",
            "text": "Inserisci le credenziali e entra nell'account.",
            "remember": {
                "label": "Ricordami ai prossimi accessi"
            }
        },
        "forgot-password": {
            "title": "Recupera password",
            "text":"Inserisci l’email dell’account per ricevere le istruzioni di recupero password.",
            "success": {
                "title": "Controlla l’email",
                "text": "Ti abbiamo inviato un email alla casella di posta inserita."
            }
        },
        "reset-password": {
            "title": "Nuova password",
            "text": "Scegli la nuova password per il tuo account e potrai nuovamente accedere."
        },
        "temp-password": {
            "title": "Nuova password",
            "text": "La password usata per il primo accesso è temporanea, scegline una nuova."
        },
        "signup": {
            "sidebar": {
                "title": "Entra nella Cerchia degli Audaci,\nimprenditore.",
                "text": "Completa i dati di registrazione e continua con il pagamento dell’abbonamento per accedere ai contenuti."
            },
            "step1": {
                "title": "Completa i dati di registrazione"
            },
            "step2": {
                "title": "Il tuo abbonamento",
                "payment_title": "Con il tuo abbonamento [sub-name] avrai:",
                "enter-osa": "Paga €[price]",
                "success-modal": {
                    "title": "Conferma pagamento,\nbenvenuto/a nella Cerchia degli Audaci.",
                    "text": "Pochi ultimi passaggi per completare il tuo profilo personale e aziendale e potrai accedere ai contenuti. Ti diamo il benvenuto!"
                }
            }
        },
        "onboarding": {
            "breadcrumb": "Completamento profilo",
            "stages": {
                "first":"Personale",
                "second":"Azienda",
                "third":"Riepilogo"
            },
            "sidebar": {
                "title":"Ti diamo il benvenuto\nnella Cerchia degli Audaci.",
                "text":"Segui gli step per controllare, aggiornare e completare i tuoi dati personali e i dati della tua azienda.\n\nI dati saranno utili per avere un **profilo pubblico** da poter inviare a clienti, fornitori e partner.",
                "example": {
                    "title": "Non sai cosa scrivere? Ecco un esempio.",
                    "name": "Mirco Gasparotto",
                    "job": "Founder di OSA"
                }
            },
            "profile": {
                "title": "I tuoi dati personali",
                "text": "Adesso parliamo di te, al prossimo passaggio potrai raccontarci la tua azienda."
            },
            "company": {
                "title": "A proposito della tua azienda",
                "text": `Se sei amministratore sei il responsabile dei dati e dei collaboratori dell’azienda. Per qualsiasi problema contatta l’[assistenza](/help).`
            },
            "recap": {
                "title": "Un rapido controllo",
                "on-you": "Su di te"
            }
        },
        "profile-dropdown": {
            "osa-profile": "Gestione profilo",
            "account": "Account e impostazioni",
            "privacy": "Gestione privacy",
            "help": "Assistenza",
            "logout": "Esci dall'account"
        },
        "profile-page": {
            "title": "Gestione profilo",
            "text": "Puoi aggiornare i dati personali e della tua/e azienda/e in qualsiasi momento. Condividi il tuo profilo per divulgare la tua presenza nella Cerchia degli Audaci.",
            "tabber": {
                "profile": "Dati personali",
                "company": "Dati aziende",
                "recommendations": "Raccomandazioni"
            },
            "show-as-visitor": "Vedi il profilo come un visitatore"
        },
        "company-info": {
            "code": {
                "text": "Condividi il codice a soci, collaboratori o partner per permettere loro di associare il proprio account alla tua azienda.",
                "placeholder": "Codice di sicurezza"
            },
            "request": {
                "title": "Richiedi un account per soci o collaboratori",
                "button": "Qui le istruzione per richiederlo",
                "text": `Una delle novità della piattaforma è che puoi richiedere un account per soci e collaboratori i quali potranno registrarsi e associarsi alla tua azienda con il codice segreto a tua disposizione. \n\n Per richiedere la creazione dell'account invia una email con Nome, Cognome e indirizzo email di ogni collaboratore o socio alla nostra casella di supporto: [${HELP_EMAIL}](mailto:${HELP_EMAIL})`
            },
            "users": {
                "title": "Utenti associati a [companyName]",
                "no-users": "Nessun collaboratore o socio"
            },
            "delete": {
                "title": "Elimina azienda",
                "text": "Sei sicuro di voler eliminare l'azienda? Questo comporterà la disassociazione di tutti gli utenti dell'azienda. L'azione è irreversibile."
            }
        },
        "home": {
            "breadcrumb": "Per te",
            "titles": {
                "video": "Video in linea con i tuoi interessi",
                "recent": "Video che hai guardato di recente",
                "category": "Formazione per “[category]”",
                "directories": "Rubriche che possono interessarti",
                "events": "Serate, webinar e live per te",
                "cta": "Call to action giornaliere",
                "workout": "Allenamenti",
                "threads": "Discussioni interessanti per te",
                "users": "Professionisti interessanti per te",
                "companies": "Aziende in evidenza oggi"
            }
        },
        "videos": {
            "breadcrumb": "Formazione",
            "filters" : {
                "search": "Cerca per parola chiave",
                "categories": "Categorie",
                "type": "Tipologia",
                "order-by": {
                    "default": "Data pubblicazione",
                    "created_at|desc": "Data pubblicazione",
                }
            },
            "titles": {
                "favorite": "Video preferiti",
                "directories": "Video rubriche",
                "all": "Tutti i video"
            },
            "no-results": "Nessun risultato con i filtri selezionati"
        },
        "single-video": {
            "breadcrumb": "...",
            "single": "Formazione singola",
            "not-found": "Video non trovato",
            "directory": "Rubrica: ",
            "description": {
                "title": "A proposito della lezione"
            }
        },
        "single-directory": {
            "breadcrumb": "...",
            "not-found": "Rubrica non trovata",
            "description": {
                "title": "Descrizione rubrica"
            },
            "directed-by": "Rubrica curata da",
            "content": "Contenuti di questa rubrica"
        },
        "single-event": {
            "breadcrumb": "...",
            "not-found": "Evento non trovato",
            "description": {
                "title": "Informazioni evento"
            },
            "full": "Esaurito!",
            "past": "Passato",
            "past-title": "Video degli interventi dell’evento",
            "tickets-available": "Posti disponibili",
            "location": "Dove si svolge l'evento?",
            "title-full": "L'evento è al pieno",
            "title-signup": "Vuoi partecipare all’evento?",
            "button-full": "Contattaci per la lista di attesa",
            "button-signup": "Vai alla pagina di dettaglio"
        },
        "single-thread": {
            "breadcrumb": "...",
            "last-updated": "Ultima modifica il [date]",
            "archived-on": "Archiviata il [date]",
            "attachment": "Allegato al messaggio",
            "type": {
                "discussion": "Discussione",
                "request": "Richiesta"
            },
            "published-on": "Pubblicata il [date] da",
            "cant-comment": "Non puoi rispondere a discussioni e richieste di account con un piano minore del tuo (non vedrebbero la risposta). Se non vuoi vedere queste discussioni puoi gestirlo dalle [impostazioni](/#/settings).",
            "best-answer": {
                "archived": "Miglior risposta",
                "temp": "Miglior risposta al momento",
                "total-votes": {
                    "single": "[count] voto totale",
                    "plural": "[count] voti totali"
                }
            }
        },
        "payment": {
            "breadcrumb": "Acquista contenuto",
            "become-knight": {
                "title": "Diventa un Cavaliere OSA!",
                "text": "Accedi a questo contenuto e molti altri con il tuo account Cavaliere OSA.",
                "button": "Scopri di più su OSA"
            },
            "title": "Cosa stai acquistando",
            "type-video": "Contenuto formazione",
            "type-directory": "Contenuto rubrica",
            "pay-btn": "Acquista ora per €[price]",
            "success": {
                "title": "Acquisto confermato",
                "text": "Grazie di aver acquistato il contenuto. Buona visione."
            }
        },
        "events": {
            "breadcrumb": "Eventi",
            "filters" : {
                "search": "Cerca per parola chiave",
                "region": "Regioni",
                "order-by": {
                    "default": "Data evento",
                    "created_at|desc": "Data pubblicazione",
                    "start_at|asc": "Data evento"
                }
            },
            "titles": {
                "favorite": "Eventi salvati",
                "all": "Tutti gli eventi in programma",
                "old": "Eventi passati da non perdere"
            },
            "no-results": "Nessun risultato con i filtri selezionati"
        },
        "threads": {
            "breadcrumb": "Richieste & Discussioni",
            "titles": {
                "all": "Tutte le richieste e discussioni",
                "archive": "Archivio",
                "highlights": "Richieste e discussioni in evidenza",
                "favorites": "Richieste preferite"
            },
            "filters": {
                "search": "Cerca argomento, imprenditore o tag",
                "type": "Tipologia",
                "categories": "Argomenti",
                "types": {
                    "all": "Tutte",
                    "request": "Richieste",
                    "discussion": "Discussioni"
                }
            },
            "no-results": "Nessun risultato con i filtri selezionati"
        },
        "people": {
            "breadcrumb": "Persone & Aziende",
            "titles": {
                "highlights": {
                    "profiles": "Imprenditori e professionisti in evidenza oggi",
                    "companies": "Aziende in evidenza oggi"
                },
                "favorites": {
                    "profiles": "Professionisti salvati",
                    "companies": "Aziende salvate"
                },
                "all": {
                    "profiles": "Tutti gli imprenditori e i professionisti",
                    "companies": "Tutte le aziende"
                }
            },
            "filters": {
                "search": "Cerca per nome azienda, nome utente o parola chiave",
                "sector": "Settore riferimento",
                "osa_hq": "Centro OSA",
                "categories": "Cerca persone influenti in",
                "roles": "Persone nel ruolo di",
                "company_size": "Dimensione azienda",
                "order-by": {
                    "default": "Ordine di default"
                },
                "all_companies": "Tutte le aziende"
            },
            "no-results": "Nessun risultato con i filtri selezionati"
        },
        "single-people": {
            breadcrumb: "...",
            "other-highlights" : "Altri che possono interessarti"
        },
        "thread-upsert": {
            "title": {
                "edit": "Modifica il messaggio",
                "new": "Nuova discussione o richiesta"
            },
            "select-type": "Scegli la tipologia",
            "types": {
                "discussion": "**Discussione**: vuoi aprire un tavolo di confronto su un tema specifico dove gli altri imprenditori potranno commentare e contribuire.",
                "request": "**Richiesta**: hai bisogno di supporto per qualcosa di specifico riguardo la tua azienda o il tuo business. Puoi scegliere in modo selettivo chi può visualizzare e rispondere."
            },
            "message-placeholder": "Il tuo primo commento",
            "select-categories": {
                "title": "Inserisci almeno 1 categoria (fino a massimo 3)",
                "placeholder": "Scrivi per cercare una categoria"
            },
            "acl-title": "Chi può visualizzare e rispondere?",
            "acl-types": {
                "everyone": "**Tutti**: tutti gli utenti della Cerchia degli Audaci, con il tuo stesso piano o superiore, potranno visualizzare e rispondere.",
                "selective": "**Selettivo**: scegli, definendo i parametri, chi può visualizzare e rispondere restringendo la cerchia sulla base delle tue esigenze.",
                "founders": `**Mirco & Alessio**: hai disponibili altre [count] richieste all’anno da poter inviare privatamente ad Alessio e Mirco (solo loro potranno visualizzare e rispondere, usalo per esigenze particolari o prioritarie). Vuoi richieste illimitate? [Contatta il supporto per un cambio piano](mailto:${HELP_EMAIL}).`,
                "founders-knight": `**Mirco & Alessio**: invia privatamente ad Alessio e Mirco (solo loro potranno visualizzare e rispondere, usalo per esigenze particolari o prioritarie).`
            },
            "button": {
                "publish": "Pubblica nella community",
                "edit": "Aggiorna dati e pubblica"
            },
            "tips": {
                "title": "Qualche consiglio utile",
                "text": "Per aprire una nuova discussione o inviare una richiesta efficace ti consigliamo di:\n\n" +
                    "• scegliere un titolo che contenga le parole chiave per facilitare la ricerca;\n\n" +
                    "• scrivere un primo commento che inviti le persone a rispondere;\n\n" +
                    "• scegliere con cura le categorie così che il sistema faccia apparire la tua discussione a chi ne è realmente interessato/a;"
            }
        },
        "suggested": {
            "title": {
                "video": "Altri video consigliati",
                "directory": "Altre rubriche consigliate",
                "event": "Altri eventi consigliati",
                "thread": "Altre discussioni consigliate"
            }
        },
        "public-profile-box": {
            "title": "Condividi il tuo profilo per farti conoscere",
            "link": "Link al profilo"
        },
        "public-profile-settings": {
            "title": "Quali sezioni vuoi rendere pubbliche?",
            "text": "Chiunque in possesso del link al tuo profilo vedrà queste informazioni.",
            "show_basic_info": "Informazioni di base",
            "show_email": "Email (dell’account)",
            "show_links": "Altri link",
            "show_phone": "Numero di telefono",
            "show_talks": "Speech per il quale eri speaker o ospite",
            "show_events": "Eventi per il quale eri speaker o ospite",
            "show_skills": "Competenze",
            "show_social_web": "Account social e sito web",
            "show_desc_languages": "Descrizione e lingue",
            "show_recommendations": "Raccomandazioni",
            "show_achievements": "Badge \"Esperto\""
        },
        "private-profile": {
            "profile-type": "[name] ha un profilo"
        },
        "public-profile": {
            "community": "Cerchia degli Audaci",
            "enter-osa": {
                "title": "Iscriviti ad OSA",
                "text": "Entra nella esclusiva community OSA e accresci le tue opportunità di business.",
                "button": "Entra in OSA"
            },
            "skills": {
                "confirmed-by": "Confermato da [number]",
                "not-confirmed": "Non confermato"
            },
            "profile": {
                "skills": "Competenze e conferme",
                "description": "Descrizione",
                "from": "Dal [date]",
                "langs": "Lingue parlate",
                "videos": "Interventi di [name]",
                "linkedin": "Profilo linkedin di [name]",
                "twitter": "[name] su Twitter",
                "website": "Sito web di [name]"
            },
            "company": {
                "linkedin": "Profilo linkedin azienda",
                "twitter": "Azienda su Twitter",
                "website": "Sito web aziendale",
                "vat": "P.IVA",
                "presentation": "Presentazione",
                "sector": "Competenze e descrizione",
                "associates": "Imprenditori di [name]",
                "from": "Dal [date]",
                "year": "Anno di costituzione",
                "dimension": "Dimensione",
                "employees": "[number] collaboratori",
                "reference-sector": "Settore",
                "products": "Dettaglio attività"
            },
            "book": {
                "title": "La storia di successo di [name] e di molti altri imprenditori!",
                "text": "[user_name] racconta la sua storia nel libro “[name]”, best seller nel settore nel business e dell’innovazione.",
                "button": "Scopri di più"
            },
            "achievements": {
                "title": "[name] ha expertise in",
                "in-category": "nella categoria [cat_name]",
                "comments": "Ha inviato ben [count] messaggi e commenti",
                "upvotes": "Ha ricevuto [count] voti ai suoi commenti",
                "best": "Ha conquistato [count] top risposte sul [cat_name]"
            }
        },
        "settings": {
            "breadcrumb": "Account e pagamenti",
            "title": "Account e impostazioni",
            "tabs": {
                "account": {
                    "title": "Account",
                    "your-account": "Il tuo account",
                    "login-data": "Dati di accesso",
                    "start": "Data inizio",
                    "end": "Scadenza",
                    "cost": "Costo",
                    "plan": "Con il tuo abbonamento [name] avrai:",
                    "upgrade-to": "Fai l'upgrade del tuo abbonamento"
                },
                "payment": {
                    "title": "Pagamenti"
                },
                "settings": {
                    "title": "Impostazioni",
                    "subtitle": "Notifiche email",
                    "other_plans": "Impostazioni visibilità contenuti",
                    "email_on_tag": "Ricevi email quando qualcuno ti tagga in un commento",
                    "email_on_news": "Ricevi email sporadiche riguardo news e attività della piattaforma",
                    "email_osa_tips": "Ricevi email sporadiche con consigli da parte di OSA",
                    "email_on_comment": "Ricevi email quando qualcuno risponde ad un commento",
                    "email_on_new_event": "Ricevi email alla pubblicazione di eventi che possono interessarti",
                    "email_on_new_content": "Ricevi email alla pubblicazione di contenuti formativi che possono interessarti",
                    "email_on_recommendation_request": "Ricevi email quando ti viene richiesta una raccomandazione",
                    "email_on_recommendation": "Ricevi un email quando ti viene inviata una raccomandazione",
                    "knight": {
                        "see_lower_plans_comments": "Visualizza i commenti su eventi e video di piani sottostanti al tuo (puoi visualizzare ma se rispondi loro non lo vedranno).",
                        "see_other_plans_threads": "Visualizza la discussioni e le richieste di aiuto di piani sottostanti al tuo (puoi visualizzare ma non puoi rispondere perché non vedrebbero la risposta)."
                    },
                    "circle": {
                        "see_lower_plans_comments": "Visualizza i commenti su eventi e video di piani sottostanti al tuo (puoi visualizzare ma se rispondi loro non lo vedranno).",
                        "see_other_plans_threads": "Visualizza la discussioni e le richieste di aiuto di piani soprastanti al tuo (puoi visualizzare ma non puoi rispondere perché non vedrebbero la risposta)."
                    }
                }
            }
        },
        "privacy": {
            "cookie": {
                "title": "Cookie"
            },
            "breadcrumb": "Gestione Privacy",
            "title": "Gestione Privacy",
            "info": {
                "title": "Informativa sulla privacy",
                "text": "Al seguente link puoi visualizzare l’informativa sulla privacy e le indicazioni sul trattamento dei tuoi dati e della tua azienda.",
                "button": "Informativa privacy"
            },
            "data": {
                "title": "Trattamento dei dati",
                "text": "Il portale Cerchia degli Audaci è stato progettato con standard qualitativi d’eccellenza e con la sicurezza dei dati dei propri utenti al primo posto. Il trattamento dei dati è conforme a quanto descritto nell’informativa sulla privacy e la progettazione è stata realizzata secondo il modello [Relactional Design](https://relactionaldesign.baasbox.com/)."
            },
            "rights": {
                "title": "I tuoi diritti",
                "text": `In qualsiasi momento puoi esercitare i tuoi diritti ed inviare una richiesta al nostro indirizzo dedicato alla gestione della privacy. Invia una email con la tua richiesta a [${HELP_EMAIL}](mailto:${HELP_EMAIL})`
            },
            "delete": {
                "title": "Elimina l'account",
                "text": "Qualora volessi eliminare l’account e concludere il rapporto con \"Cerchia degli Audaci\" e/o con il portale puoi inviarci una richiesta e provvederemo a contattarti per stabilire le modalità della cancellazione di tutti i dati che abbiamo attualmente registrato.",
                "button":  "Clicca qui."
            }
        },
        "change-password": {
            "title": "Cambia password"
        },
        "notifications": {
            "no-more-notifications": "Non ci sono altre notifiche di attività",
            "notification-number": "[count] nuove attività",
            "item": {
                "today":"[hours] - oggi",
                "yesterday": "[hours] - ieri",
                "titles": {
                    "comment-video": "Commento al video “[text]”",
                    "comment-thread": "Commento alla discussione “[text]”",
                    "comment-event": "Commento all'evento “[text]”",
                    "content": "Nuovo contenuto in “[text]”",
                    "event": "Nuovo evento pubblicato in zona “[text]”",
                    "tag": "Qualcuno ti ha menzionato in un commento in “[text]”",
                    "recommendation": "[text] ti ha inviato una raccomandazione!",
                    "recommendation_request": "[text] ti ha richiesto una raccomandazione",
                    "skill_confirmation": "[text] ti ha confermato la competenza “[skill]”",
                    "skill_confirmation_company":"[text] ha confermato la competenza “[skill]” della tua azienda “[company]”"
                }
            }
        },
        "helpcenter": {
            "menu-title": "Helpcenter",
            "title": "Bisogno di aiuto?",
            "text": "Hai un problema con il tuo account o la piattaforma? Siamo qui per darti il supporto massimo, h24.",
            "placeholder": "Di cosa hai bisogno?",
            "no-results": "Nessun risultato"
        },
        "validation": {
            "profile": {
                "firstName": "Il nome è obbligatorio",
                "image": "L'immagine del profilo è obbligatoria",
                "lastName": "Il cognome è obbligatorio",
                "gender": "Il genere è obbligatorio",
                "office": "La sede OSA è obbligatoria",
                "userBio": "La descrizione è obbligatoria",
                "phone": "Il telefono è obbligatorio",
                "languages": "Le lingue sono obbligatorie",
                "skills": "Inserisci almeno 3 competenze",
                "interests": "Inserisci almeno 3 interessi"
            },
            "company": {
                "name": "Il nome dell'azienda è obbligatorio",
                "vat": "La partita iva è obbligatoria",
                "creationYear": "L'anno di creazione è obbligatorio",
                "employees": "Il numero dipendenti è obbligatorio",
                "osaCenter": "La sede osa è obbligatoria",
                "referenceSector": "Il settore di riferimento è obbligatorio",
                "phone": "Il telefono è obbligatorio",
                "email": "L'email è obbligatoria",
                "min_address": "Inserisci almeno una sede",
                "address": "Una sede inserita non è valida"
            }
        },
        "thread-leaderboards": {
            "title": "Classifica degli esperti",
            "messages": {
                "single": "[count] messaggio",
                "plural": "[count] messaggi"
            },
            "best-answers": {
                "single": "[count] top risposta",
                "plural": "[count] top risposte"
            },
            "modal": {
                "button": "Come funziona la classifica?",
                "title": "Più contribuisci, più crei rete, più cresci.",
                "text": "Gli esperti di ogni categoria sono calcolati sulla base del numero di discussioni al quale si è partecipato, del numero di messaggi inviati e del numero di risposte ritenute migliori nei thread di categoria (con almeno 5 voti). \n\n" +
                    "Più commenti invii, più crei rete, più contribuisci e più cresci professionalmente spiccando rispetto gli altri nella tua area di competenza migliore.\n" +
                    "Grazie di far parte di questa grande community!"
            }
        },
        "recommendation_box": {
            "what_you_can_do": "Cosa puoi fare:",
            "recommendation_requested": "[name] ti ha chiesto una raccomandazione!",
            "send_message": "Invia messaggio",
            "request": "Richiedi raccomandazione",
            "write": "Scrivi la raccomandazione",
            "ignore": "Ignora la richiesta",
            "recommendation_received": "Raccomandazione ricevuta da [name]",
            "recommendation_sent": "La tua raccomandazione per [name]",
            "request_success": "La richiesta è stata inviata con successo."
        },
        "profile-recommendations": {
            "hidden": "Nascosta - ",
            "recommendations_sent": {
                "single": "[num] Raccomandazione inviata",
                "plural": "[num] Raccomandazioni inviate"
            },
            "not_approved_recommendations": {
                "single": "[num] Raccomandazione ricevuta da verificare",
                "plural": "[num] Raccomandazioni ricevute da verificare"
            },
            "approved_recommendations": {
                "single": "[num] Raccomandazione ricevuta e accettata",
                "plural": "[num] Raccomandazioni ricevute e accettate"
            },
            "requests_received": {
                "single": "[num] Raccomandazione richiesta da inviare",
                "plural": "[num] Raccomandazioni richieste da inviare",
                "text": "Ti ha richiesto una raccomandazione il [date]"
            },
            "requests_sent": {
                "single": "[num] Raccomandazione richiesta e in attesa",
                "plural": "[num] Raccomandazioni richieste e in attesa",
                "text": "Hai richiesto una raccomandazione il [date]"
            }
        },
        //ERRORS
        "internal_server_error": "Errore generico.",
        "generic_error": "Errore generico",
        "credentials_not_valid": "Le tue credenziali non sono corrette. Riprova.",
        "title_required": "Il titolo è obbligatorio",
        "message_required": "Il messaggio è obbligatorio",
        "categories_required": "Scegli almeno una categoria"
    }
}